<template>
  <div>
    <div id="home">
      <img style="width: 30vw;" src="../assets/imgs/animation.gif"/>
      <h1>예상 퇴직금을<br/>계산하고 있습니다</h1>
      <p>잠시만 기다려 주세요</p>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex'
  import moment from 'moment/moment';
  import { getAction,postAction } from '@/network/manage';
  import { signMethod } from '@/utils/sign';
  export default {
    name: 'Loading',
    components: {

    },
    data() {
      return {

      }
    },
    created(){
      this.queryInit()
    },
    methods:{
      async queryInit(){
        const that  = this
        if(Vue.ls.get('joinDate') && Vue.ls.get('leaveDate') && Vue.ls.get('salary')){
          const res = await getAction('/app/common/getPension',{
            startDate:Vue.ls.get('joinDate'),
            endDate:Vue.ls.get('leaveDate'),
            money:Vue.ls.get('salary')
          })
          if(res.success){
            Vue.ls.set("money", res.result)
            if(Vue.ls.get('kakaoPhone') != null
            && Vue.ls.get('kakaoPhone') != ''
            && Vue.ls.get('name') != null
            && Vue.ls.get('name') != '') {
              //init contract
              const timestampMs = Date.now();
              const params = {
                name: Vue.ls.get('name'),
                phoneNumber: Vue.ls.get('kakaoPhone'),
                email: Vue.ls.get('email'),
                nickname: Vue.ls.get('nickname'),
                joiningDate: moment(Vue.ls.get('joinDate')).format('YYYY-MM-DD'),
                departureDate: moment(Vue.ls.get('leaveDate')).format('YYYY-MM-DD'),
                totalPayroll: Vue.ls.get('salary'),
                timestamp: timestampMs,
                sign: signMethod(Vue.ls.get('kakaoPhone'), Vue.ls.get('name'),timestampMs)
              }
              const res = await postAction('/app/applicationRecord/addRecord', params)
              if(res.success) {
                Vue.ls.remove('kakaoPhone')
                Vue.ls.remove('name')
                Vue.ls.remove('email')
                Vue.ls.remove('nickname')
                Vue.ls.remove('joinDate')
                Vue.ls.remove('leaveDate')
                Vue.ls.remove('salary')
                setTimeout(function(){
                  that.$router.replace('/phoneResult')
                },1000)
              } else {
                this.$router.replace('/')
              }
            } else {
              setTimeout(function(){
                that.$router.replace('/result')
              },2000)
            }
          }
        }else{
          this.$router.replace('/')
        }
      },
      init_sign() {

      }
    }
  }
</script>

<style scoped>
  *{font-size:16px;font-size:inherit;box-sizing: border-box;margin:0px;padding:0px;}
  #home{height: 100vh;display: flex;flex-direction: column;width: 100%;padding:20px;align-items: center;justify-content: center;}
  h1{color:#333333;font-size: 24px;text-align: center;margin:20px 0 10px 0;}
  p{color: #717B85;text-align: center;}

</style>
